export const translateEN = {
  ACADEMIC_PROGRESS: "Academic progress",
  ACCEPT_SEQUENCE: "Accept Sequence",
  ACTIVE: "Active",
  ADD_ANOTHER_LANGUAGE: "Add language",
  ADD_EMAIL: "Add email",
  ADD_LANGUAGE: "Add language",
  ADD_NEW_COMPANY: "New company",
  ADD_NEW_LINGO: "Add Lingo",
  ADD_NEW_STUDENT: "New student",
  ADD_NEW_TICKET: "New Ticket",
  ADD_NEW: "Add new",
  ADD_TEACHER: "New teacher",
  ADD_TELEPHONE: "Add Phone",
  ADD_TO_CONTRACT: "Add to contract",
  ADDRESS_PLACEHOLDER: "Address",
  ADDRESS: "Address",
  ADVANCED: "Advanced",
  ALL_LANGUAGES: "All Languages",
  ALTERNATIVE_EMAIL: "Alternative email",
  ANALYTICS: "Analytics",
  APP: "App",
  ASSIGNED_TEACHER: "Assigned Teacher",
  AVAILABLE_PART_CLASSES: "Extra Classes",
  AVARAGE_RATING: "Average rating",
  AVERAGE: "Average",
  BACK: "Back",
  BALANCED: "Balanced",
  BASIC: "Basic",
  BILINGUAL: "Bilingual",
  BILLING_HISTORY: "Billing history",
  BILLED_MONTHLY: "billed monthly",
  BIRTH_DATE: "Date of birth",
  BTN_ADD_NEW_CONTACT: "New contact",
  BTN_ADD_NEW_PLAN: "Add plan",
  BTN_ADD_TEL: "Add telephone",
  BTN_ADD: "Add",
  BTN_BACK: "Back",
  BTN_BUY_PLAN: "Buy new plan",
  BTN_CANCEL_ALL_CLASS: "Cancel all the sequences of classes",
  BTN_CANCEL_ONLY_CLASS: "Cancel this sequence of classes",
  BTN_CANCEL: "Cancel",
  BTN_CLASS_SCHEDULED: "Class Scheduled!",
  BTN_CLASS_WITHOUT_TECHER: "Classes without teacher",
  BTN_CLEAR_SEARCH: "Clear search",
  BTN_CLOSE: "Close",
  BTN_CONFIRM: "Confirm",
  BTN_CREATE_ACCOUNT: "Create my account",
  BTN_DAYS_TO_REPEAT_CLASS: "Select the days to repeat the classes",
  BTN_DELETE: "Delete",
  BTN_DEMO_CLASS_WITHOUT_TECHER: "Demo classes without teacher",
  BTN_END_TIME: "End time",
  BTN_ENGLISH: "English",
  BTN_HELLO: "Hello",
  BTN_LOGIN: "Login",
  BTN_NEW_CLASS: "New class",
  BTN_NO_CLASSES_FOUND: "No classes found",
  BTN_NO: "No",
  BTN_NOT_CANCEL_CLASS: "Ooops! I dont want to cancel my class",
  BTN_NUMBER_CLASSES: "Number of classes",
  BTN_PORTUGUESE: "Portuguese",
  BTN_PROCEED_PAYMENT: "Proceed to payment",
  BTN_REGULAR: "Regular",
  BTN_REPEAT_UNITIL: "Repeat until",
  BTN_REQUEST: "request",
  BTN_REVERSE_PAYMENT: "Reverse payment",
  BTN_REVERSED_PAYMENT: "Class Reversed",
  BTN_SAVE: "Save",
  BTN_SCHEDULE_ADDED: "Your class has been added to your schedule!",
  BTN_SCHEDULE_CLASS: "Schedule class",
  BTN_SCHEDULE_NEW_CLASS: "Schedule a new class",
  BTN_SCHEDULE: "Schedule",
  BTN_SEARCH: "Search",
  BTN_SEND: "Send",
  BTN_SPANISH: "Spanish",
  BTN_SPECIFIC: "Specific",
  BTN_START_TIME: "Start time",
  BTN_UPCOMING_CLASS: "Upcoming classes",
  BTN_VIEW_ALL: "View all",
  BTN_VIEW_SCHEDULE: "View Schedule",
  BTN_VIEW: "View",
  BTN_YES_LOVE: "Yes, I love it!",
  BTN_YES: "Yes",
  BULK_ADD_NEW_STUDENT: "Bulk add student",
  BULK_ADD_STUDENT: "Bulk add student",
  BULK_RESULTS: "Results",
  BUY_MORE_CLASSES: "Buy Classes",
  CANCEL_ALL_CLASSES_MESSAGE: "Cancellation of this class will result in all classes listed above being canceled.",
  CANCEL_ALL_FIXED_CLASSES_MESSAGE:
    'Cancellation of this class will result in all classes listed above being canceled. If you wish to cancel all fixed classes, select the option "Cancel all classes"',
  CANCEL_CLASS: "Cancel Class",
  CANCEL_CLASS_OUT_OF_LIMIT: "ATTENTION! You will miss class",
  CANCEL_DATE: "Cancel date",
  CANCEL_LATER_RATE: "Cancel, I`ll rate it later",
  CANCEL_MESSAGE_REPEAT: "This scheduled class is set to repeat",
  CANCEL_MESSAGE_TICKET: "Why you want to cancel your ticket?",
  CANCEL_MESSAGE: "Why you want to cancel your class?",
  CANCEL_MESSAGE_OUT_OF_LIMIT:
    "You are about to cancel your class outside the allowed time limit (1 hour), so it will be counted as a given class. Are you sure you want to cancel your class?",
  CANCEL_MY_PLAN: "Cancel my plan",
  CANCEL_OPENDED_TICKET: "Cancel my opended ticket",
  CANCEL_PLACEHOLDER: "Please tell us why you want to cancel your class",
  CANCEL_PLAN_MENSSAGEM_2:
    "It would be valuable for us to have your assessment, on a scale of 1 to 10, regarding your experience with our classes and teaching approach. Would you be willing to assist us by providing this feedback?",
  CANCEL_PLAN_MENSSAGEM: "We are disappointed to hear about your departure 🙁",
  CANCEL_PLAN: "Cancel plan",
  CANCEL_IMMEDIATE: "Immediate Cancellation",
  CANCEL_IMMEDIATE_MESSAGE: "By making an immediate cancellation, the student will not be able to make more schedules.",
  CANCEL_IMMEDIATE_QUESTION: "Are you sure you want to cancel immediately?",
  CANCEL_TICKET: "Cancel ticket",
  CANCEL: "Cancel",
  CANCELED_CYCLE: "canceled",
  CANCELLED_LINGO: "Cancelled by Lingo",
  CANCELLED: "Cancelled",
  CANCELED: "Canceled",
  CANCELLED_PLAN: "Cancelled plan",
  CANCELLED_OUT_lIMIT: "Out of Limit",
  CARD_CLASS_ASSOCIATED: "Associated Schedules",
  CARD_CLASS_ATTENDED: "Was the class Given?",
  CARD_CLASS_CANCEL: "Cancel Information",
  CARD_CLASS_CANCELLED: "Class cancelled",
  CARD_CLASS_CONFIRMED: "Confirmed",
  CARD_CLASS_CONTENT: "Class content",
  CARD_CLASS_COORDINATOR: "Coordinator",
  CARD_CLASS_DETAILS: "Class details",
  CARD_CLASS_DONE: "Class done",
  CARD_CLASS_REASON: "Reason",
  CARD_CLASS_STUDENT: "Student",
  CARD_CLASS_TEACHER: "Teacher",
  CARD_LIST_CUSTOM_SERVICE: {
    cancelled: "Cancelled",
    inProgress: "In progress",
    closed: "Closed",
    open: "Open",
    companyManager: "Company Manager",
    b2b: "B2B",
    student: "Student",
    customerService: "Customer Service",
    teacher: "Teacher",
    affiliate: "Affiliate",
    coordinator: "Coordinator",
  },
  CARD_PLAN_CLASS: "Classes",
  CARD_PLAN_COURSE: "Lingo",
  CARD_PLAN_LEVEL: "Level",
  CARD_PLAN_SCHEDULE: "Scheduling Control",
  CARD_PLAN: "Plan",
  CELLPHONE: "Mobile",
  CENCELLED_TICKET: "Your ticket has been canceled!",
  CHANCE_PICTURE: "Change",
  CHANGE_PASSWORD_DESCRIPTION: "Set your new password",
  CHANGE_PASSWORD_TITLE: "Change Password",
  CHANGE_PASSWORD: "Change Password",
  CHANGE_PLAN: "Change",
  CHANGE: "Change",
  CHANGE_CARD_ERROR: "Your card is not compatible. Please try a different card.",
  CHANGE_CARD_TITLE: "Change your credit card",
  CHECK_IN: "Check In",
  CHECK_OUR_PLANS: "Try for free",
  CHECK_PASS_PLACEHOLDER: "Confirm new password",
  CHECK_PASS: "Repeat password",
  CHOOSE_LIST_TEACHER: "Choose a list",
  CHOOSE_YOUR_PLAN: "Choose your plan",
  CLASS_CANCELED: "Class canceled",
  CLASS_CANCELED_IN: "Class canceled in",
  CLASS_CONVERTED: "Class Converted",
  CLASS_DETAILS_ACCESS_CLASS: "Access the classroom",
  CLASS_DETAILS_BEFORE_CLASS: "Before class",
  CLASS_DETAILS_EDIT_CLASS: "Edit class",
  CLASS_LINK: "Classroom",
  CLASS_RATING: "Class Rating",
  CLASS_SCHEDULE_EDIT_MODAL_SUBTITLE: "Class edition",
  CLASS_SCHEDULE_MODAL_SUBTITLE: "Class scheduling",
  CLASS_SUB_CANCELED: "Canceled",
  CLASS_SUB_CONFIRMED: "Confirmed",
  CLASS_SUB_DONE: "Done",
  CLASS_SUB_NOSHOW: "No Show",
  CLASS_SUB_PENDING: "Pending",
  CLASS_SUBJECT: "Enter the class subject",
  CLASS_TITLE: "Class title",
  CLASS_TOOL: "Class Tool",
  CLASS_TYPE: "Class type",
  CLASS: "Class",
  CLASSES_TODAY: "Today you have",
  CLASSES: "Classes",
  CLEAR_FILTERS: "Clear filters",
  CLOSED_TICKET: "Your ticket has been closed!",
  CLOSED: "Closed",
  COPIED_CLIPBOARD: "Copied to clipboard",
  CONFIRMED: "Confirmed",
  COMERCIAL_RESPONSIBLE_NAME: "Name of Sales Manager",
  COMERCIAL_RESPONSIBLE: "Comercial Responsible",
  COMMENTS: "Comments",
  COMMERCIAL: "Commercial",
  COMPANY_INFO: "Companies",
  COMPANY_MANAGER: "Company Manager",
  COMPANY_NAME: "Company Name",
  COMPANY: "Company",
  COMPLEMENTARY_EXERCISES: "Complementary exercises",
  CONFIRM_PASS_INVALID: "Please fill your confirmation password!",
  CONFIRMATION: "Confirmation",
  CONTACT: "Contact",
  CONTACTS: "Contacts",
  CONTENT: "Content",
  MY_CONTENT: "My content",
  CONTRACT_NUMBER: "Contract number",
  CONTRACT: "Contract",
  CONTRACTS_INFO: "Contracts",
  COORDINATED_LANGUAGES: "Lingo that Coordinates",
  COORDINATOR: "Coordinator",
  COPY: "Copy",
  COUNTRIES: "Countries",
  COUNTRY: "Country",
  COUPON_INVALID: "Coupon Invalid",
  COUPON_VALID: "Coupon Valid",
  COUPON: "Coupon?",
  COUPONS_INFO: "Coupons",
  CREATOR_USER_ID: "User",
  CURRENT_TIME: "Current Time",
  CREATE_COMMISSION: "Create commission",
  CUSTOMER_SERVICE: "Customer Service",
  CYCLE_NAME: "Cycle name",
  CYCLE: "Cycle",
  DATA_TIME: "Date and Time",
  DATE_CHANGE_PLAN: "This plan will be active on the day",
  DATE_CREATED: "Date created",
  DATE_FORMAT: "MM/DD/YYYY",
  DATE: "Date",
  DAY: "Day",
  DAYS: "Days",
  DELETE_TEACHER: "Delete Teacher",
  DELETE: "Delete",
  DEMO_CLASS_CONTENT: "Demo Class / ",
  DEMO_CLASS_CONTENT1: "First Class",
  DEMO_CLASS: "Demo Class",
  DEMO_TYPE: "Demo type",
  DESCRIPTION_MODAL_SEND_METHOLOGY: "Methodology content sent successfully!",
  DESCRIPTION_MODAL_SEND_PROGRESS: "Academic Progress content sent successfully!",
  DESCRIPTION_PLAN_EXPIRED: "Your trial period is over! Buy a new plan by clicking the button below!",
  DESCRIPTION: "Description",
  DICTATION: "Dictation",
  DOCUMENT_NUMBER: "Company ID",
  DONE: "Done",
  DONT_HAVE_ACTIVE_PLAN: "Oh no! You don’t have an active plan 🙁",
  DOUBLE_CLICK: "Double click to change",
  DOWNLOAD_APP: "Are you on your phone? Download our app. Click below!",
  DURATION: "Duration",
  ECONOMIC_GROUP: "Economic Group",
  EDIT_COMPANY: "Edit company",
  EDIT_CLASS: "Edit",
  EDIT_CONTENT: "Edit Content",
  EDIT: "Edit",
  EMAIL_ERROR: "Incorrect Email",
  EMAIL_INVALID: "E-mail Invalid, please check!",
  EMAIL_PLACEHOLDER: "Your email",
  EMAIL_REQUIRED: "E-mail Invalid, please check!",
  EMAIL: "Email",
  END_TIME: "End time",
  END: "End",
  ENGLISH: "English",
  ENTER_COUPON_PLACEHOLDER: "Enter coupon",
  ENTER_NAME: "Enter Name",
  ENTER_PERCENTAGE_VALUE: "Enter % Value",
  ENTER_TICKET: "Enter Ticket",
  ERROR_DIALOG: "Something went wrong, try again later.",
  EXCEPTION_TEACHER: "Exception",
  EXCLUSION_LEVELS: "Exclusion levels",
  EXPIRED_ON: "Expired on",
  EXPIRES_ON: "Expires on",
  EXTRA_CLASS_PRICE: "Extra Class Price",
  EXTRA_CLASS_USED_PLURAL: "Extra classes used",
  EXTRA_CLASS_USED_SINGLE: "Extra class used",
  EXTRA_CLASS: "Extra Class",
  EXTRA_CLASSES: "Extra classes",
  EXTRA_EMAIL_PLACEHOLDER: "Another email",
  EXTRA_EMAIL: "Alternative email",
  FAVORITE_TEACHER: "Favorite",
  FEMALE: "Female",
  FIELD_IS_REQUIRED: "Field {{fieldName}} is required",
  FILTER: "Filter",
  FILTERS: "Filters",
  FINAL_TEST: "Final test",
  FIRST_ACESS_TEXT_B2B: "Before starting classes, please complete your registration and set a new password",
  FIRST_ACESS_TEXT: "Before starting classes, please complete your registration",
  FIRST_CLASS: "First Class",
  FOCUS: "Content",
  FORGET_TITLE: "Recover password",
  FORGOT_PASS: "Forgot password?",
  FRENCH: "French",
  FREE: "Free",
  GENDER: "Gender",
  GENERATE_REPORT: "Generate Report",
  GRADES: "Grades",
  GROUP: "Group",
  HAVE_ACCOUNT: "Have an account?",
  HISTORY: "History",
  HOME: "Home",
  HOURS: "Horas",
  HOW_MANY_CLASSES: "How many classes",
  I_AGREE: "I agree with the",
  I_WANT_TO_SCHEDULE_MY_CLASSES: "I want to schedule my classes",
  IN_PROGRESS: "In Progress",
  IN_STOCK: "in stock",
  IN_THIS_TIMEZONE: "In This Timezone",
  INACTIVE: "Inactive",
  INDEX_KEY_ERROR: "en_US",
  INDEX_KEY_STRING: "nameEnglish",
  INTERMEDIATE: "Intermediate",
  INVALID_FORM_DESCRIPTION: "Fill the required informations and try again.",
  INVALID_FORM_TITLE: "Alert!",
  INVOICE: "Invoice",
  ISACTIVE: "Active",
  ITEM_ACCOUNT: "My Account",
  ITEM_CUSTOMER_SERVICE: "Customer Service",
  ITEM_SCHEDULE: "Schedule",
  ITEM_STUDENTS: "Students",
  ITEM_TEACHERS: "Teachers",
  LANGUAGE_KEY_STRING: "english",
  LANGUAGE_LEVEL: "Language level",
  LANGUAGE: "Language",
  LANGUAGES: "Languages",
  LAST_INTERACTION: "Last Interaction",
  LEGAL_NAME: "Legal Name",
  LEVEL_BY_STUDENT: "Level by Student",
  LEVEL_SCORE: "Level & Scores",
  LEVEL: "Level",
  LEVELS: "Levels",
  LINGO_ADV: "Advanced",
  LINGO_EMAIL: "Email Registered",
  LINGO_INTER: "Intermediate",
  LINGO: "Lingo",
  LINK_SUBSCRIPTION: "https://www.lingofor.me/lingo-us/lingo_aula_demo.html",
  LIST: "List",
  LOAD_MORE: "View more",
  LOCAL_CLASS_TIME: "Local class time",
  LOCALE: "en-us",
  LOGIN_EMAIL: "Login email",
  LOGIN_SUBS: "Sign Up",
  LOGOUT: "Logout",
  MALE: "Male",
  MANAGE: "Manage Plan",
  MANAGE_ACCOUNT_TITLE: "Manage Account",
  MANAGE_HOURS_NOTIME: "No time slots available for scheduling on this day",
  MANAGE_HOURS_TITLE: "Add your available time slots for each day of the week",
  MAXIMUM_STUDENTS: "The maximum students per plan limit reached",
  MESSAGE_BACK_RESET_CYCLE: "Jobs are asynchronous and may take a few minutes to finish.",
  MESSAGE_EDIT: "Updated",
  MESSAGE_INFO_BILINGUE_NATIVO: `By selecting "Native" all your new English class scheduling will be with native teachers. By selecting "Bilingual" you will have bilingual teachers.`,
  MESSAGE_INFO_CONTENT_REGULAR: `Regular: The teacher will follow our methodology and materials that will allow you to advance in our different levels of study.`,
  MESSAGE_INFO_CONTENT_SPECIFIC: `Specific: The teacher will be able to help you with any material you provide and thus you can clarify specific doubts, for example, writing an email, understanding a document, etc.`,
  MESSAGE_INFO_REPEAT: `In this option you can repeat the scheduling by selecting the days and until what date you want the scheduling to be repeated.`,
  MESSAGE_CONFIRM_CHANGE_CLASS:
    "Because your class starts in less than 1 hour, making changes at this time counts as a late cancellation.\nIf you continue:\nYour existing class will be cancelled and deducted from your monthly credits.\nThe new class time will be booked as an additional session.",
  MESSAGE_LANGUAGE: "en_US",
  TITLE_CONFIRM_CHANGE_CLASS: "Important Notice: Late Reschedule Policy",
  MESSAGE_MODAL_VERSION:
    "We have a new application update and we need to log you out in order to apply it. Please log in again.",
  MESSAGE_RESET_CYCLE: "Do you really want to reset the cycles?",
  MESSAGE_SAVE: "Registered",
  METHODOLOGY: "Methodology",
  MODAL_RELOAD_MESSAGE: "You changed your timezone, please login again!",
  MODAL_RELOAD_SUBJECT: "Timezone changed",
  MODAL_RELOAD_SUBJECT_TIME: "Modified schedule format",
  MODAL_RELOAD_MESSAGE_TIME: "Please log in again",
  MODULE: "Scheduling",
  MONEY_FORMAT: "U$",
  MONTH: "Month",
  MONTHLY: "per month",
  MULTYPLE_CLASSES_MESSAGE:
    "This class is part of a multiple class scheduling. By accepting it, you will be assigned to the entire sequence:",
  MULTYPLE_CLASSES: "MULTIPLE CLASSES",
  NAME_PLACEHOLDER: "Your name",
  NAME_REQUIRED: "Please fill your name!",
  NAME: "Name",
  NATIVE_LANGUAGE: "Native Language",
  NATIVE: "Native",
  NEW_BTN_RESET_CYCLE: "Cycle reset",
  NEW_CONTENT: "New Content",
  NEW_USER: "Not registered?",
  NEW: "New",
  NIVEL_A0: "Beginner",
  NIVEL_A1: "Pre-Elementary",
  NIVEL_A2: "Elementary",
  NIVEL_B1: "Intermediate",
  NIVEL_B2: "Upper-Intermediate",
  NIVEL_C1: "Advanced",
  NIVEL_C2: "Proficiency",
  NIVEL_DM: "Maintenance",
  INTERVIEW: "Interview",
  NO_NOTIFICATIONS: "No Notifications",
  NO_RESULTS: "No Results",
  NO_THANKS: "No Thanks",
  NO: "No",
  NOSHOW_MESSAGE_MODAL: "The class will change status to {{status}}, do you want to continue?",
  NOSHOW: "No Show",
  NOT_AUTHORIZED: "Login not authorized",
  NOT_INFORMED: "Not Informed",
  NOT_REGISTERED: "Not registered? ",
  NOTES_HISTORY: "Notes History",
  NOTIFICATION_SETTINGS: "Notifications Settings",
  NOTIFICATION_TITLE: "Control where you receive notifications from Lingo:",
  NOTIFICATION: "Notifications",
  NOTIFICATIONS: "Notifications",
  O_K: "Ok",
  OBSERVATION: "Observation",
  OCCUPATION: "Occupation",
  OOOPS_CANCEL_MY_PLAN: "Oops! I don't want to cancel my plan",
  OOOPS_DONT: "Oops! I don't want to cancel my ticket ",
  OPEN_DATE: "Opening date",
  OPEN_NEW_TICKET: "Open New Ticket",
  OPEN: "Open",
  OPTION_CORRECTIONS_RATING_COMMENTS: "Only has me reading without interaction",
  OPTION_EXPLAIN_RATING_COMMENTS: "Speaks my native language excessively",
  OPTION_EXPRESSION_RATING_COMMENTS: "Unclear explanations make understanding difficult",
  OPTION_LOUD_RATING_COMMENTS: "I feel better connection with others",
  OPTION_OTHER_RATING_COMMENTS: "Other",
  OPTION_TALK_RATING_COMMENTS: "Speaks fast and doesn't correct mistakes",
  OPTIONS: "Options",
  OR_LOGIN_TXT: "or login with",
  OR_LOGIN: "or login with",
  ORAL: "Oral",
  ORDER_COMPLETE: "Confirmation",
  ORDER_DETAILS: "Order details",
  ORDER_REVIEW: "Review & Pay",
  ORDER: "Order",
  OTHER_LANGUAGE: "Other Language",
  OTHER_LANGUAGES: "Other languages",
  PARAMETERS: "Parameters",
  PASS_ERROR: "Required field",
  PASS_INVALID_MESSAGE:
    "invalid password! Minimum of six characters, at least one letter, one number and one special character like @$!%*#?&[]{},.;<>:/~^´`-_() !",
  PASS_INVALID: "Please fill your password!",
  PASS_NOT_MATCH: "Your password and confirmation password do not match, Please check!",
  PASS_NOTEQUAL_MESSAGE: "The password Fields need be equals",
  PASS_PLACEHOLDER: "Your password",
  PASSWORD_CHANGE: "Password changed successfully!",
  PASSWORD_CONFIRM: "Confirm password",
  PASSWORD_ERROR: "Invalid login or password",
  PASSWORD_NOT_MATCH: "Passwords must be identical",
  PASSWORD: "Password",
  PAYMENT_ID: "Payment ID",
  PAYMENT_METHOD: "Payment Method",
  PAYMENT: "Payment",
  PENDING: "Pending",
  REVIEW: "Review",
  PER_MONTH: "per month",
  PERIOD_END: "Period - end",
  PERIOD_START: "Period - start",
  PERIOD: "Period",
  PERSONAL_DATA: "Personal information",
  PERSONAL_INFO: "Personal Information",
  PERSONAL_INFORMATION: "Personal Information",
  PHONE_PLACEHOLDER: "Telephone",
  PHOTO: "Photo",
  PLAN_BALANCED: "Balanced",
  PLAN_BUSINESS: "Business",
  PLAN_BUY: "Buy plan",
  PLAN_CONVERSATIONAL: "Conversational",
  PLAN_DOWNGRADE: "Downgrade plan",
  PLAN_GRAMMAR: "Grammar",
  PLAN_NOT_FOUND: "Plan not found",
  PLAN_RENOVATION: "Reverse cancelation",
  PLAN_RENOVATION_MESSAGE:
    "Upon reversing the cancelation, the system will continue with automatic monthly collection for your next class period.",
  PLAN_TRADITIONAL: "Traditional",
  PLAN_UPGRADE: "Upgrade plan",
  PLAN: "Plan",
  PLANS_AND_PRICING: "Plans & Prices",
  PLANS: "Plans",
  PLEASE_TELL_CANCEL_MESSAGE_TICKET: "Please tell us why you want to cancel your ticket",
  PORTUGUESE: "Portuguese",
  POWER: "Power",
  PRICE_IN: "Prices in USD",
  PROCEED_TO_PAYMENT: "Proceed to Payment",
  PROFILE: "Profile",
  PROVIDER: "Provider",
  PUSH: "Push",
  PUSH_GENERATOR: "Push generator",
  RANDOM: "Random",
  RATE: "Rate",
  RATING_AVG_INFO: "Rating",
  RATING_CONFIRMED: "Rated",
  RATING_DESCRIPTION_TEACHER: "Would you like to have more classes with this teacher?",
  RATING_INFO_PLURAL: "Pending",
  RATING_INFO_SINGULAR: "Pending",
  RATING_MODAL_TITLE: "Please, rate the following classes",
  RATING_PENDING_INFO_PLURAL: "ratings",
  RATING_PENDING_INFO_SINGULAR: "rating",
  RATING_PENDING: "Pending",
  RATING: "Rating",
  REAL_LEVEL: "Real Level",
  REFER_YOUR_FRIENDS_AND_EARN: "The Refer and Earn program has reached a new payout record!",
  REFUND: "Refund",
  REFUND_MESSAGE: "When making a refund, the student will receive a refund of their last payment.",
  REFUND_QUESTION: "Are you sure you want to make the refund?",
  REMEMBER_ACCESS: "Remember me",
  REPEAT: "Do you want to repeat this schedule on other days?",
  REPORT: "Report",
  REQUESTED_PLAN: "Requested Plan",
  REQUIRED_FIELD: "Required",
  REQUIRED: "Required",
  RESET_CYCLE: "on the next restart cycle",
  RESETS_ON: "Resets on",
  RESIDENCIAL: "Residencial",
  RESEND: "Resend",
  REVIEW_AND_PAY: "Review and Pay",
  REVIEW_INFORMATION: "Review your information",
  REVIEW_PLAN: "Review your plan ",
  REVIEW_YOUR: "Review Your ",
  SAVE_FORM_DESCRIPTION: "Information successfully saved!",
  SAVE_FORM_TITLE: "Success!",
  SAVE: "Save",
  SCHEDULE: "Schedule",
  SCHEDULING_CONTROL: "Scheduling Control",
  SEARCH_USER: "Search user",
  SELECT_LANGUAGE_LEVEL: "Please fill your language level!",
  SELECT_LANGUAGE_PLAN_TITLE: "Select a language plan",
  SELECT_LANGUAGES: "Please fill your language!",
  SELECT_TEACHER: "Select a teacher",
  SELECT_TIME_FORMAT: "Select the time format",
  SELECT_TIMEZONE: "Choose Time Zone",
  SELECT_THE_LINK: "Select the link you want to send:",
  SELECT: "Select",
  SEND: "Send",
  SEQUENTIAL_CLASS_MESSAGE: "This class is part of the following sequence of classes:",
  SETTINGS_NOTIFY: "Notification Settings",
  SETTINGS: "Settings",
  SHARE: "Follow us",
  SHCEDULING_IN: "Scheduling In",
  SHOWING_OF: "of",
  SHOWING: "Showing",
  SIGN_UP: "Check our plans",
  SIGNATURE_DATE: "Signature Date",
  SIGNATURE_PENDING: "Signature pending",
  SINCE: "Since",
  SING_IN: "Sign in",
  SOCIAL_MEDIA: { LOGIN_ERROR: "Failed to log in" },
  SOMETHING_WENT_WRONG: "Something went wrong",
  SPANISH: "Spanish",
  START_TIME: "Start time",
  START: "Start",
  STATUS_CHANGE: "Status Change",
  STATUS: "Status",
  STRUCTURE: "STRUCTURE",
  STUDENT_ADDRESS: "Student Address",
  STUDENT_COMPANY_NAME: "Student Company Name",
  STUDENT_COMPANY: "Company Name",
  STUDENT_EMAIL: "Student Email ",
  STUDENT_LINK: "Student link",
  STUDENT_MESSAGE_EDIT: "Updated Student",
  STUDENT_MESSAGE_SAVE: "Registered student",
  STUDENT_NAME: "Name of the student",
  STUDENT_OCCUPATION: "Student Position",
  STUDENT_PHONE: "Student Phone",
  STUDENT_TOOL_ID: "Student ID",
  STUDENT: "Student",
  STUDENTS_TIMEZONE: "Students Timezone",
  STUDENTS: "Students",
  SUBSCRIPTION: "Subscription",
  SUBSCRIPTION_DATE: "Subscription Date",
  SUBTYPE: "Subtype",
  SUCCESS_MESSAGE: "Success!",
  SUCCESS_CHANGE_CARD: "Your card has been updated, the next payment will be deducted from it.",
  SUCESS_CANCEL_PLAN: "Your plan was cancelled. You can schedule classes until the end of your billing cycle.",
  SUCESS_CANCEL_PLAN_MANAGE: "Plan was cancelled.",
  SWARMING_TITLE: "High Demand Schedule",
  TARGET_CLASSES_PER_MONTH: "Target classes per month",
  TEACHER_AVERAGE_RATING: "Teacher Average Rating",
  TEACHER_LINK: "Teacher's link",
  TEACHER_NAME: "Teacher Name",
  TEACHER_TYPE: "Teacher Type",
  TEACHER: "Teacher",
  TEACHERS: "Teachers",
  TEL_REQUIRED: "Cellphone Invalid, please check!",
  TELEPHONE_COMMERCIAL: "Telephone Commercial",
  TELEPHONE_MOBILE: "Telephone Mobile",
  TELEPHONE: "Telephone",
  TELL_US_CANCEL_MY_PLAN: "Please tell us why you want to cancel your plan",
  TERMS_OF_USE: "Online Learning Agreement",
  TERMS_OF: "terms of use ",
  THIS_PLAN: "This plan will be",
  TICKET_ID: "Ticket #",
  TICKET_MESSAGE: "Your ticket has been opened",
  TICKET_NUMBER: "Ticket number",
  TICKET_TITLE: "Congratulations!",
  TICKET_VIEW: "View ticket",
  TICKETS: "Tickets",
  TIME_SLOT_DURATION: "Time slot duration",
  TIMEZONE: "Timezone",
  TITLE_MODAL_SEND: "Success!",
  TITLE_MODAL_VERSION: "New version available!",
  TITLE_PLAN_EXPIRED: "Your plan has expired!",
  TITLE: "Title",
  TODAY: "Today",
  TOOL_ID: "Tool ID",
  TOTAL_CLASSES: "Total classes",
  TOTAL_CYCLES: "Total cycle",
  TOTAL_QUIZZES: "Total quizzes",
  TRAINING: "Training",
  TRANSACTION_ID: "Transaction ID",
  TRIAL_CLASS: "Trial Class",
  TRY_AGAIN: "Try Again",
  TYPE_MESSAGE: "Type a message...",
  TYPE: "Type",
  UNITARY_VALUE: "Unitary value",
  UNTIL: "Until",
  UPDATE_SCREEN: "Update",
  USER_INFO: "Your information",
  USERS: "Users",
  VALID_FORM_DESCRIPTION: "Password changed successfully!",
  VALID_FORM_TITLE: "Success",
  VALIDATE_SCHEDULE_DATE_PAST: "Class cannot be past",
  VALIDATE_SCHEDULE_DATE: "Date is required",
  VALIDATE_SCHEDULE_FOCUS: "Content is required",
  VALIDATE_SCHEDULE_LANG: "Language is required",
  VALIDATE_SCHEDULE_NATIVE_BILINGUE:
    "The native/bilingual option has not been selected, it is necessary to choose the type of teacher for this class",
  VALIDATE_SCHEDULE_NUM_CLASSES: "Number of classes is required",
  VALIDATE_SCHEDULE_PLAN: "Plan is required",
  VALIDATE_SCHEDULE_REPEATEND: "Repeat until is required",
  VALIDATE_SCHEDULE_START: "Start time is required",
  VALIDATE_SCHEDULE_WEEKREPEAT: "At least one week day is required",
  VALIDATE: "Validate",
  VALIDATION_ERROR: "Validation error",
  VALUE: "Value",
  VIEW_MORE: "View More",
  VIEW: "View",
  VIEW_CONTRACT: "View contract",
  WEBSITE: "Website",
  WEEK: "Week",
  WEEK_FRIDAY: "Friday",
  WEEK_MONDAY: "Monday",
  WEEK_SATURDAY: "Saturday",
  WEEK_SUNDAY: "Sunday",
  WEEK_THURSDAY: "Thursday",
  WEEK_TUESDAY: "Tuesday",
  WEEK_WEDNESDAY: "Wednesday",
  WELCOME_TITLE: "Welcome to ",
  WHAT_TYPE_OF_TEACHER: "What type of teacher do you want to have in this class?",
  WHATSAPP: "WhatsApp",
  WHATSAPP_SUPPORT: "WhatsApp Support",
  WITHOUT_TEACHER: "Without Teacher",
  WORDOFTHEDAY: "Word of the day",
  WRITING: "Writing",
  YES: "Yes",
  YOUR_EXTRA_CLASSES_IS_ALL_SET: "Your extra classes is a ready",
  YOUR_PLAN: "Your plan will be",
  YOUR_TIMEZONE: "Your Timezone",

  PRODUCTIVITY: "Productivity",
  SALES_LINK: "Referral Link",
  DISCLOSURE: "Disclosure",
  TRANSACTIONS: "Transactions",
  CONTRACTS: "Contracts",
  BRONZE: "Bronze",
  BLUE: "Blue",
  GOLD: "Gold",
  SILVER: "Silver",
  PLATINUM: "Platinum",
  SALES: "referrals",
  SALES1: "Referrals",
  PRIVILEGE: "Privilege",
  PRIVILEGES: "Privileges",
  CONTRACT_PENDING: "Your contract is pending",
  MONTHLY_PRIVILEGES: "Privileges are monthly",
  PRODUCTIVITYINFO1: "You need to",
  PRODUCTIVITYINFO2: "referrals to reach the level",
  MY_TRANSACTIONS: "My transactions",
  MY_COMMISSION: "My commission",
  MINIMUM_WITHDRAWAL1: "Minimum of",
  MINIMUM_WITHDRAWAL2: "for withdrawal",
  VISITS: "Visits",
  DEMOS: "Demos",
  CONVERSIONS: "Conversions",
  FLAT: "Plan",
  TOTAL: "Total",
  MENU: "Menu",
  MY_SALES_LINK: "My referral link",
  SHORT_LINK: "Short link",
  SHARE_SOCIAL_NETWORKS: "Share on social media",
  LINK_COPIED: "Link copied to clipboard.",
  MESSAGE_SHARE: "teste mensagem lingo",
  CURRENT_BALANCE: "Current balance",
  CONCLUDED: "Concluded",
  WITHDRAWAL: "Withdrawn",
  PAYMENTO_LINGO: "Lingo Payment",
  COMMISSION: "Commission",
  CONVERSION: "Conversion",
  SUBTITLE: "Legend",
  SUBTITLE_COMMISSION: "Value vs Time",
  SUBTITLE_CONVERSION: "Referral vs Time",
  AFFILIATE: "Affiliate",
  AFFILIATES: "Affiliates",
  ADD_PROFILE_PHOTO: "Add a profile photo.",
  ADD_TAX_INFORMATION: "Add your tax information.",
  ADD_PAYMENT_INFORMATION: "Select a payment method",
  TERMS_OF_USE_AFFILIATE: "Terms of use",
  BTN_ACCEPT: "Accept",
  PROFILE_PICTURE: "Profile photo",
  SUCCESS_MESSAGE_PHOTO: "Your photo has been added successfully!",
  PAYMENT_METHOD_LABEL: "Enter the method and user of the account",
  SUCCESS_MESSAGE_PATMENT_METHOD: "Your payment details have been added successfully!",
  FISCAL_DOCUMENT: "What is your social security number?",
  OTHER: "Other",
  BRAZILIAN_ADDRESS: "Brazilian address",
  AMERICAN_ADDRESS: "American address",
  ADRESSE_COLOMBIENNE: "Colombian address",
  ADRESSE_MEXICAINE: "Mexican Address",
  ALERT_TAX_INFORMATION:
    "Important: You have selected the option for US tax residents.All information must be verified since it will be used to generate 1099s.",
  SUCCESS_MESSAGE_TAX_INFORMATION:
    "The information was registered satisfactorily, The contract has been sent to your email ready for your signature.",
  ALERT_MESSAGE_TAX_INFORMATION: "The contract has been sent to your email ready for your signature.",
  TAX_INFORMATION: "Tax Information",
  CITY: "City",
  STATE: "State",
  ZIPCODE: "Zipcode",
  CITIZENSHIP_COUNTRY: "What country of your citizenship?",
  WHERE_LIVE_COUNTRY: "Where are you located?",
  MODAL_PAYAMENT_ALERT01: "Enter the email you use to log in to the selected payment gateway. ",
  MODAL_PAYAMENT_ALERT02: "Important: ",
  MODAL_PAYAMENT_ALERT03:
    " you must check your email, as once the payment has been processed we cannot request a refund.",
  SALES_LINK_PT: "Link in Portuguese",
  SALES_LINK_ES: "Link in Spanish",
  SALES_LINK_US: "Link in English",
  BONUS: "Bonus",
  CORPORATE_NAME: "Company name",
  COMMUNICATION_LANGUAGE: "Communication Language",
  PHYSICAL_PERSON: "Natural Person",
  LEGAL_PERSON: "Legal Entity",
  AFFILIATE_PROGRAM_TITLE: "Affiliate program ($)",
  AFFILIATE_PROGRAM_DESCRIPTION: "Sign up for free and start receiving!",
  BE_AFFILIATED: "Refer and Earn",
  PAID: "Paid",
  NO_ITEMS_FOUND: "No items found...",
  TOTAL_LIFETIME_COMMISSION: "Total lifetime commission",
  PAY_ALL: "Pay all",
  MODAL_AFFILIATE_STUDENT_TITLE1: "Earn up to ",
  MODAL_AFFILIATE_STUDENT_TITLE2: "$ 75.20 dollars",
  MODAL_AFFILIATE_STUDENT_TITLE3: "per plan referred",
  MODAL_AFFILIATE_STUDENT_SUBTITLE1: "Be one of the first Lingofor.me affiliates",
  MODAL_AFFILIATE_STUDENT_SUBTITLE2: "Generate extra income in dollars!",
  MODAL_AFFILIATE_STUDENT_BUTTON: "Get started now!",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE1: "1 - Share your referral link",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE2: "2 - Demo class scheduling",
  MODAL_AFFILIATE_STUDENT_CARD_TITLE3: "3 - Receive the commission in dollars",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE1: "Share your exclusive referral link with friends, family and colleagues.",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE2:
    "Every student referred to the course can schedule a free trial class to get to know the method and the platform.",
  MODAL_AFFILIATE_STUDENT_CARD_SUBTITLE3: "Earn commission of up to $75.20 for each successful referral.",
  ITEM_CARD_AFFILIATE1: "Payment in Dollars.",
  ITEM_CARD_AFFILIATE2:
    "Earn up to $75.20 for every referral that purchases a plan using your exclusive referral link.",
  ITEM_CARD_AFFILIATE3: "Biweekly payments.",
  ITEM_CARD_AFFILIATE4: "The more people you refer, the greater the possibility of contracted plans.",
  ITEM_CARD_AFFILIATE5: "Refer in any country, we have students in more than 34 countries.",
  ITEM_CARD_AFFILIATE6: "More than 400,000 classes held on the platform.",
  ITEM_CARD_AFFILIATE7: "Excellent student feedback",
  ITEM_CARD_AFFILIATE8: "All plans are multilingual",
  ITEM_CARD_AFFILIATE9: "Monthly plans and no cancelation penalty for students",

  JANUARY: "January",
  FEBRUARY: "February",
  MARCH: "March",
  APRIL: "April",
  MAY: "May",
  JUNE: "June",
  JULY: "July",
  AUGUST: "August",
  SEPTEMBER: "September",
  OCTOBER: "October",
  NOVEMBER: "November",
  DECEMBER: "December",
  JAN: "Jan",
  FEB: "Feb",
  MAR: "Mar",
  APR: "Apr",
  JUN: "Jun",
  JUL: "Jul",
  AUG: "Aug",
  SEP: "Sep",
  OCT: "Oct",
  NOV: "Nov",
  DEC: "Dec",

  CREATE_YOUR_ACCOUNT: "Create your account",
  NAME_FULL: "Full Name",
  BTN_NEXT: "Next",
  SELECT_COUNTRY: "Select your country",
  REVIEW_SUBSCRIPTION_TITLE: "Review subscription",
  ABBREVIATED_DISCOUNT: "Disc.",
  REVIEW_SUBSCRIPTION_TEXT1: "Your plan renews monthly automatically.",
  REVIEW_SUBSCRIPTION_TEXT2: "You can cancel automatic renewal at any time.",
  REVIEW_SUBSCRIPTION_TEXT3: "The monthly fee for the chosen plan is",
  REVIEW_SUBSCRIPTION_TEXT4: "which will be charged monthly according to the day of registration.",
  PRIVACY_TERMS_TEXT: "I agree to the automatic renewal terms above.",
  ALL_OUR_PLANS: "All our plans are multilingual",
  SIGN_FOR_LINGO: "By signing up with Lingo, you agree to the terms above and our",
  PRIVACY_POLICY: "Privacy Policy.",
  BTN_BUY: "Buy",
  THANKS: "Thank you!!",
  A_PARTNER: "A partner:",
  WELCOME_TO_LINGO: "Your plan purchase was completed successfully! Welcome to Lingo!",
  WELCOME_TO_LINGO_CHANGE: "Your plan purchase was completed successfully!",
  BTN_MANAGR_ACCOUNT: "Access my user",
  MINUTE_CLASSES_MONTH: "30-minute classes per month",
  ITEM_CARD_INFO1: "Multilingual plans",
  ITEM_CARD_INFO2: "Private classes with live teachers",
  ITEM_CARD_INFO3: "Practical classes focused on conversation.",
  ITEM_CARD_INFO4: "Free scheduling (24/7)",
  ITEM_CARD_INFO5: "No registration fee, materials or penalty for cancelation.",
  ITEM_CARD_INFO6: "Monthly and automatic invoicing.",
  ITEM_CARD_INFO7: "Classes are not cumulative for a subsequent period",
  ITEM_CARD_INFO8: "Apps for",
  INVALID_PASS1: " At least 6 characters",
  INVALID_PASS2: " At least 1 letter",
  INVALID_PASS3: " At least 1 number",
  INVALID_PASS4: " At least 1 special character ",
  INVALID_PASS5: " Both passwords must be the same.",
  INVALID_FORM_CHECKOUT1: "The name is mandatory!",
  INVALID_FORM_CHECKOUT2: "The email is mandatory!",
  INVALID_FORM_CHECKOUT3: "The email is invalid!, please check your email.",
  INVALID_FORM_CHECKOUT4: "The cell phone number is mandatory!",
  INVALID_FORM_CHECKOUT5: "Country selection is mandatory!",
  INVALID_FORM_CHECKOUT6: "You must agree to the privacy terms to continue.",
  INVALID_FORM_CHECKOUT7: "The user",
  INVALID_FORM_CHECKOUT7_1: " already exists, click the login button to enter your account.",
  INVALID_FORM_CHECKOUT8: "Unable to load plan information, please try later.",
  INVALID_FORM_CHECKOUT9: "The company name field is required",
  INVALID_FORM_CHECKOUT10: "The birth date is required!",
  INVALID_FORM_CHECKOUT11: "You must be over 18 years old to register!",
  INVALID_FORM_CHECKOUT12: "The language field is required",
  INVALID_FORM_CHECKOUT13: "Please complete the reCAPTCHA!",

  SAME: "Same",
  BEST_SELLER: "Best Seller",
  CARD: "Card",
  NEW_CARD: "Enter a new card as a payment method.",
  NEXT_CYCLE: "Your subscription will change at the next payment cycle renewal.",
  ACTIVATION: "Activation",
  SCHEDULED: "Scheduled",
  IMMEDIATE: "Immediate",
  CHANGE_NOW: "Your subscription will be changed to the new plan right now.",

  NEW_MULTI_STUDENT: "NEW",
  SUBTITLE01: "From now on your plan is MULTI-LANGUAGE",
  SUBTITLE02: "Study English, Spanish, Portuguese and French (coming soon), without paying more for it!",

  TITLE_ALERT_NEWS: "New Update",
  SUBTITLE01_ALERT_NEWS: "Say goodbye to sticky notes and double-checking your schedule! 🚀",
  SUBTITLE02_ALERT_NEWS:
    "Our newest update is here: Full integration with Google Calendar. Now, your classes magically appear in your personal calendar as soon as you create a new appointment.",
  SUBTITLE03_ALERT_NEWS: "✅ Never forget again",
  SUBTITLE04_ALERT_NEWS: "✅ Everything in one place",
  SUBTITLE05_ALERT_NEWS: "✅ Real-time updates",
  SUBTITLE06_ALERT_NEWS: 'Try it today! Go to "My Account" > Notifications and connect your Google account to Lingo.',

  REPORT_FORM: "Report",
  CLASSES_HELD: "Content given",
  CLASS_COMMENTARY: "Comment",
  EVALUATED: "Completed",
  ASSESSED_LATE: "Filled late",
  SELECT_STUDENT_LEVEL: "Select student level",
  STUDENT_PERSONAL_PROFILE: "Proposed content",
  ADD_SPECIFIC_CLASS: "Add specific content",
  CLASS_NOT_COMPLETED: "Content incomplete",
  PAGE: "Page",
  SPECIFY_NEXT_TEACHER: "Specify where the next teacher should continue:",
  MORE_CLASSES: "More content",
  COMMUNICATE_SOMETHING_COORDINATOR: "Do you want to communicate something to the coordinator?",
  ENTER_STATEMENT_HERE: "Enter the statement here",
  YES_COMMUNICATE: "YES, I want to communicate!",
  FINISH: "Finish",
  NO_FINISH: "No, just finish it!",
  ACCEPT: "Accept",
  STUDENT_LEVEL: "Student level",
  FILL: "Fill",
  EXPIRES_AT: "Expires at:",
  PENDENT: "Fill",
  DELAYED: "Filled late",
  PAGE_COMMENT_REQUIRED: "Page and comment required.",

  AFTER_CLASS: "After the class",
  FILL_FORM: "Fill form",
  FILL_REPORT: "Fill Report",
  PREVIOUS_CLASSES: "Previous classes",
  LATEST_APPOINTMENTS: "Latest scheduling",
  CODE: "Code",
  STUDENT_DESCRIPTION: "Student description",
  CLASS_NOT_COMPLETED_CONTINUE: "Class incompleted. Continue at:",
  WAITING_TEACHER_UPDATE: "Waiting for teacher update",
  CLASS_EXPIRED: "Class expired",
  WAITING_TEACHE_UPDATE: "Waiting for teacher update",
  TITLE_ALERT_ADD_CONTENT_SPECIFIC: "Specific Content",
  DESCRIPTION_ALERT_ADD_CONTENT_SPECIFIC:
    "The specific content is exclusively for classes where lingofor.me material was not used or for M1 level classes. Are you sure you want to continue with this type of content?",

  DETAIL: "Detail",
  OUT_OF_LIMIT: "out of limit",
  FORMS_FILL: "forms to fill",
  FORM_DETAIL: "Form Detail",
  UPCOMING_MATERIALS: "Upcoming Content",
  FIRST_CLASS_CONTENT:
    "You can now track your progress more accurately in the new content menu. You will have your upcoming materials and the history of what you have seen in your last three sessions.",

  TITLE_STUDENT_CONTENT: "What's new on Lingofor.me",
  DESCRIPTION_STUDENT_CONTENT:
    "You can now track your progress more accurately in the new content menu. You will have your upcoming materials and the history of what you have seen in your last 3 classses.",

  DEPARTMENT: "Department",
  REPORT_UPDATE: "Report Update",

  LOADING: "Loading...",
  QUESTIONNAIRES: "Questionnaires",
  OPEN_MODAL_QUESTIONNAIRES: "Personal information for immigration",
  NO_QUESTIONS_AVAILABLE: "No questions available",
  MESSAGE_ALERT_QUESTIONNAIRES:
    "The following questionnaire is essential to begin your immigration interview practice, as it contains all the personal information our instructors need to correct and verify. Please answer each question clearly and thoroughly.",

  CONNECT_YOUR_GOOGLE_ACCOUNT: "Connect your Google account to sync your appointments with your Personal Calendar.",
  GOOGLE_CALENDAR: "Google Calendar",
  SYNC_YOUR_GMAIL_ACCOUNT: "Sync your Gmail account.",
  MICROSOFT_OUTLOOK: "Microsoft Outlook",
  SYNC_WITH_YOUR_OUTLOOK_ACCOUNT: "Sync with your Outlook account",
  CONNECT: "Connect",
  CONNECTED: "Connected",
  CONNECTING: "Connecting",
  GO_TO_NOTIFICATIONS: "Go to notifications",

  SUGESTIONS: "Suggestions",
  TYPE_YOUR_SUGGESTIONS: "Type your suggestions",

  AI_PRACTICE: "Practice with AI",
  AI_PRACTICE_TITLE: "Practice with Lingo AI",
  AI_PRACTICE_DESCRIPTION: "Lingo AI will generate personalized exercises for you to practice outside of class.",
  AI_PRACTICE_LIST_DESCRIPTION:
    "The following list shows the most recent topics covered in your classes. You can select up to {{count}} of them and Lingo AI will generate exercises according to your level so you can practice.",
  AI_PRACTICE_TOPICS_AVAILABLE: "Topics available for practice",
  AI_PRACTICE_TEACHER_RECOMMEND: "What your teachers recommend you practice...",
  AI_PRACTICE_SELECT_TOPICS: "Select topics",
  AI_PRACTICE_MY_HISTORY: "My history",
  AI_PRACTICE_GENERATE: "Generate",
  AI_PRACTICE_EMPTY_TITLE:
    "After your first lesson in this language, the option to generate exercises will be enabled so you can start practicing.",

  MY_HISTORY_EXERCISES: "Exercises",
  MY_HISTORY_TOPICS: "Topics",
  MY_HISTORY_CREATION_DATE: "Creation date",
  MY_HISTORY_LAST_UPDATE: "Last update",
  MY_HISTORY_SCORE: "Score",
  MY_HISTORY_SUGGESTIONS: "Lingo AI suggestions",
  MY_HISTORY_REDO: "Answer the same exercises you already did and improve your grade.",
  MY_HISTORY_GENERATE_NEW: "Generate new and different exercises on the same topic and practice more.",
  MY_HISTORY_NO_ITEMS_FOUND:
    "You haven't generated your first exercises yet. Click the 'Back' button, select the topics you want to practice, and then click the 'Generate' button.",
  MY_HISTORY_VIEW_RESULTS: "Click to see the results",

  IDEAL_FOR_RESUMING_YOUR_STUDIES_WITH_EASE: "Ideal for resuming your studies with ease.",
  MORE_FREQUENCY_TO_ACCELERATE_YOUR_PROGRESS: "More frequency to accelerate your progress.",
  PREMIUM_PLAN_FOR_MAXIMUM_PROGRESS: "Premium plan for maximum progress.",
};
